"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePickingWinner = void 0;
const useCreatorDataApi_1 = require("root/src/client/logic/api/hooks/useCreatorDataApi");
const useInterval_1 = __importDefault(require("root/src/client/web/hooks/useInterval"));
/**
 * Cron runs around ~22s of minute
 */
const POLLING_INTERVAL = 8000;
const usePickingWinner = () => {
    const { fetchGiveaways } = (0, useCreatorDataApi_1.useCreatorDataApi)();
    (0, useInterval_1.default)(() => __awaiter(void 0, void 0, void 0, function* () {
        yield fetchGiveaways();
    }), POLLING_INTERVAL);
};
exports.usePickingWinner = usePickingWinner;
